import React from 'react';
import cn from '@/utils/cn';
import Icon from '@/components/ui/Icon';
import Text from '@/components/ui/Text';
import { BaseVersion } from '@/types/api/v2/VersionSchema';

interface SuccessMessageProps {
  revertedVersions: BaseVersion[];
}

export const SuccessMessage = ({ revertedVersions }: SuccessMessageProps) => {
  const revertedImageIds = [...new Set(revertedVersions.map(version => version.meta.revert_to))];

  const message = revertedImageIds.length === 1 ? (
    `Image ID ${revertedImageIds[0]} is now the primary version.`
  ) : (
    `Image IDs ${revertedImageIds.join(', ')} are restored as the primary versions.`
  );

  return (
    <div
      className={cn(
        'tw-bg-green tw-bg-opacity-5 tw-border-green tw-border tw-rounded-xl',
        'tw-border-solid tw-py-3 tw-px-2 tw-flex tw-gap-3 tw-mb-2',
      )}
    >
      <div
        className={cn(
          'tw-bg-green tw-text-white tw-rounded-full tw-w-6 tw-h-6',
          'tw-inline-flex tw-items-center tw-justify-center',
        )}
      >
        <Icon icon="Check" size={15} />
      </div>
      <div className="tw-flex tw-flex-col tw-gap-1">
        <Text className="!tw-text-green" variant="body" weight="bold">Merge successfully reverted</Text>
        <span className="tw-text-very-dark-grey">{message}</span>
      </div>
    </div>
  );
};
